// extracted by mini-css-extract-plugin
export default {"container":"RangeSelector_container__Hr7+l"};